import { motion, useReducedMotion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const MaskedLine = ({ children, delay = 0, className = "", scroll = false }) => {
    const reduce = useReducedMotion();
    const transition = { duration: 1.05, delay, ease: EASE };
    if (scroll) {
        return (
            <motion.span
                className={`block overflow-hidden ${className}`}
                initial={reduce ? false : "hidden"}
                whileInView="show"
                viewport={{ once: true, margin: "-60px" }}
            >
                <motion.span
                    className="block will-change-transform"
                    variants={{ hidden: { y: "112%" }, show: { y: "0%" } }}
                    transition={transition}
                >
                    {children}
                </motion.span>
            </motion.span>
        );
    }
    return (
        <span className={`block overflow-hidden ${className}`}>
            <motion.span
                className="block will-change-transform"
                initial={reduce ? false : { y: "112%" }}
                animate={{ y: "0%" }}
                transition={transition}
            >
                {children}
            </motion.span>
        </span>
    );
};

export const FadeUp = ({ children, delay = 0, className = "", y = 36 }) => {
    const reduce = useReducedMotion();
    return (
        <motion.div
            className={className}
            initial={reduce ? false : { opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-70px" }}
            transition={{ duration: 0.9, delay, ease: EASE }}
        >
            {children}
        </motion.div>
    );
};

export const Grow = ({ children, delay = 0, className = "" }) => {
    const reduce = useReducedMotion();
    return (
        <motion.div
            className={className}
            style={{ transformOrigin: "left center" }}
            initial={reduce ? false : { scaleX: 0 }}
            whileInView={{ scaleX: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1, delay, ease: EASE }}
        >
            {children}
        </motion.div>
    );
};
